import mobileCarousel from "../modules/utils/mobileCarousel";
mobileCarousel('section-realizations__wrapper', 'section-realizations__arrow', 1.25, 16, false);